import { ApiClient } from "./apiClient";

const brandingRequestURL = "/branding/";
export const instanceRequest = () => ApiClient.public().get('/instance/');

export const brandingRequest = async (store) => {
  return ApiClient.private(store).get(brandingRequestURL);
};
